export { default as getGlobalTheme } from '../get-global-theme';
